import React from 'react'
import SideBar from './SideBar'

function RenderPage({children}) {
  return (
    <div className='md:flex min-h-screen max-h-screen overflow-y-hidden'>
        <div className='md:min-w-[60px] md:max-w-[60px]'>
        <SideBar />
        </div>
        <div className='w-[100%] md:min-h-screen md:max-h-screen overflow-y-scroll px-4'>
        {children}
        </div>
    </div>
  )
}

export default RenderPage